/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Centralisation des routes API
const API_ROUTES = {
  GET_CATEGORY: `/api/home/category_get`,
  GET_PRODUCTS: `/api/home/product_get`,
  GET_PRODUCT_DETAILS: `/api/home/get_product_details/`,
  PRICE_RANGE_PRODUCTS: `/api/home/price-range-latest-products`,
  QUERY_PRODUCTS: `/api/home/query_sort_products`,
  CUSTOMER_REVIEW: `/api/home/customer-review`,
  GET_PRODUCT_REVIEW: `/api/home/product/get-reviews`,
  GET_BANNERS: `/api/home/banner/get_all_banners`,
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

// Fetch categories
export const get_category = createAsyncThunk(
  "category/get_category",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(API_ROUTES.GET_CATEGORY, {
        withCredentials: true,
      });
      //console.log("API Response (categories):", data);
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Error fetching categories:", error);
      // return rejectWithValue(error.response?.data.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Fetch products
export const get_products = createAsyncThunk(
  "product/get_products",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(API_ROUTES.GET_PRODUCTS, {
        withCredentials: true,
      });
      //console.log("API Response (products):", data);
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Error fetching products:", error);
      // return rejectWithValue(error.response?.data.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const get_product_details = createAsyncThunk(
  "product/get_product_details",
  async (productId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        API_ROUTES.GET_PRODUCT_DETAILS + `${productId}`,
        { withCredentials: true },
      );
      //console.log("API Response product details:", data);
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Error fetching products:", error);
      // return rejectWithValue(error.response?.data.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const price_range_products = createAsyncThunk(
  "product/price_range_products",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(API_ROUTES.PRICE_RANGE_PRODUCTS, {
        withCredentials: true,
      });
      //console.log("API Response (products):", data);
      return fulfillWithValue(data);
    } catch (error) {
      //console.error("Error fetching products:", error);
      // return rejectWithValue(error.response?.data.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
export const query_products = createAsyncThunk(
  "product/query_products",
  async (query, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `${API_ROUTES.QUERY_PRODUCTS}?categorie=${query.categorie}&&rating=${query.rating}
                &&lowPrice=${query.min}&&highPrice=${query.max}&&sortPrice=${query.sortPrice}&&pageNumber=${query.pageNumber}
                &&searchValue=${query.searchValue ? query.searchValue : ""}`,
        { withCredentials: true },
      );
      //console.log("API Response (query_products):", data);
      return fulfillWithValue(data);
    } catch (error) {
      //console.error("Error fetching products:", error);
      //return rejectWithValue(error.response?.data.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const customer_review = createAsyncThunk(
  "review/customer_review",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        `${API_ROUTES.CUSTOMER_REVIEW}/${info.productId}`,
        info,
        { withCredentials: true },
      );
      //console.log("API Response (customer_review):", data);
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Error fetching products:", error);
      // return rejectWithValue(error.response?.data.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const get_product_review = createAsyncThunk(
  "review/get_product_review",
  async ({ productId, pageNumber }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `${API_ROUTES.GET_PRODUCT_REVIEW}/${productId}?&&pageNumber=${pageNumber}`,
        { withCredentials: true },
      );
      //console.log("API Response (get_product_review):", data);
      return fulfillWithValue(data);
    } catch (error) {
      // Gérer les autres types d'erreurs

      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Fetch products
export const get_banners = createAsyncThunk(
  "banner/get_banners",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(API_ROUTES.GET_BANNERS, {
        withCredentials: true,
      });
      //console.log("API Response (banners):", data);
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Error fetching products:", error);
      // return rejectWithValue(error.response?.data.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const homeReducer = createSlice({
  name: "home",
  initialState: {
    loading: false,
    categories: [],
    products: [],
    totalProducts: 0,
    parPage: 5,
    latestProducts: [],
    topRatedProducts: [],
    topDiscountedProducts: [],
    priceRangeLatestProducts: [],
    popularProducts: [],
    topOrderedProducts: [],
    topShops: [],
    priceRange: {
      min: 50,
      max: 500000,
    },
    errorMessage: "",
    successMessage: "",
    product: {},
    moreProducts: [],
    relatedProducts: [],
    reviews: [],
    rating_review: [],
    totalReviews: 0,
    hasReviews: false,
    bannerLoading: false,
    reviewsError: "",
    banners: [],
    bannerError: "",
    bannerSuccess: "",
    reviewsLoading: false,
    reviewsSuccess: "",
    clientLocation: {},
    seller: {},
    shippingFee: 0,
    currentPage: 0,
    video: {},
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
      state.reviewsError = "";
      state.reviewsSuccess = "";
      state.bannerError = "";
      state.bannerSuccess = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Category actions
      .addCase(get_category.pending, (state) => {
        state.loading = true;
        state.errorMessage = "";
      })
      .addCase(get_category.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage =
          action.payload || "An error occurred while fetching categories.";
      })
      .addCase(get_category.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload.categories;
        state.clientLocation = action.payload.clientLocation;
      })

      // Product actions
      .addCase(get_products.pending, (state) => {
        state.loading = true;
        state.errorMessage = "";
      })
      .addCase(get_products.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage =
          action.payload || "An error occurred while fetching products.";
      })
      .addCase(get_products.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.products;
        state.latestProducts = action.payload.latestProducts;
        state.topRatedProducts = action.payload.topRatedProducts;
        state.topDiscountedProducts = action.payload.topDiscountedProducts;
        state.popularProducts = action.payload.popularProducts;
        state.topOrderedProducts = action.payload.topOrderedProducts;
        state.topShops = action.payload.topShops;
      })
      //
      .addCase(price_range_products.pending, (state) => {
        state.loading = true;
        state.errorMessage = "";
      })
      .addCase(price_range_products.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage =
          action.payload || "An error occurred while fetching products.";
      })
      .addCase(price_range_products.fulfilled, (state, action) => {
        state.loading = false;
        state.priceRangeLatestProducts =
          action.payload.priceRangeLatestProducts;
        state.priceRange = action.payload.priceRange;
      })
      .addCase(query_products.pending, (state) => {
        state.loading = true;
        state.errorMessage = "";
      })
      .addCase(query_products.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage =
          action.payload || "An error occurred while fetching products.";
      })
      .addCase(query_products.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.products;
        state.totalProducts = action.payload.totalProducts;
        state.parPage = action.payload.parPage;
      })
      .addCase(get_product_details.pending, (state) => {
        state.loading = true;
        state.errorMessage = "";
      })
      .addCase(get_product_details.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = "";
      })
      .addCase(get_product_details.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload.product;
        state.relatedProducts = action.payload.relatedProducts;
        state.moreProducts = action.payload.moreProducts;
        state.shippingFee = action.payload.shippingFee;
        state.seller = action.payload.seller;
        state.video = action.payload.video;
      })
      .addCase(customer_review.pending, (state) => {
        state.loading = true;
        state.errorMessage = "";
      })
      .addCase(customer_review.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = "";
      })
      .addCase(customer_review.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage =
          action.payload.message || "Review submitted successfully";
      })

      .addCase(get_product_review.pending, (state) => {
        state.reviewsLoading = true;
        state.reviewsError = "";
        state.reviewsSuccess = "";
      })
      .addCase(get_product_review.rejected, (state, action) => {
        state.reviewsLoading = false;
        state.reviewsError =
          action.payload.message || "Aucun avis pour ce produit";
      })

      .addCase(get_product_review.fulfilled, (state, action) => {
        state.reviewsLoading = false;
        state.reviewsError = "";
        state.reviewsSuccess =
          action.payload.message || "Reviews loaded successfully";
        state.reviews = action.payload.reviews || [];
        state.totalReviews = action.payload.totalReviews || 0;
        state.rating_review = action.payload.rating_review || []; // Choisis number OU array, pas les deux !
        state.currentPage = action.payload.currentPage || 0;
      })

      .addCase(get_banners.pending, (state) => {
        state.bannerLoading = true;
        state.bannerError = "";
        state.bannerSuccess = "";
      })
      .addCase(get_banners.rejected, (state, action) => {
        state.bannerLoading = false;
        state.bannerError = action.payload.message || "Une erreur est survenue";
        state.bannerSuccess = "";
      })
      .addCase(get_banners.fulfilled, (state, action) => {
        state.bannerLoading = false;
        state.bannerSuccess =
          action.payload.message || "Banners chargés avec succès";
        state.banners = action.payload.banners || [];
      });
  },
});

export const { messageClear } = homeReducer.actions;
export default homeReducer.reducer;
